/*
  PC_FG_01 importing the necessary functions and packages
*/
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getFAQ, deleteFAQ } from '../../service/todo';
import Loader from '../../StaticComponent/Loader';
import './css/faq.css';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';

import { encryptStorage } from '../../constant';

export function FAQList() {
    /**
     * PC_FG_02 creating state variables
     */
    let faqBody = [],
        role;
    let Role = encryptStorage.getItem('role');
    const navigate = useNavigate();
    const [faqData, setfaqData] = useState(faqBody);
    const [categoryID, setCategoryID] = useState('1');
    const [catId, setcatId] = useState('1');
    const [userRole, setUserRole] = useState(Role);
    const [deleteID, setDeleteID] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const { state } = useLocation();

    /**
     * PC_FG_03 invoking loadAccordion to the faqs
     */
    useEffect(() => {
        //
        if (state?.catId != undefined && state?.catId != null) {
            setcatId(state.catId);
            setCategoryID(state.catId);
            loadAccordion(state.catId);
        } else loadAccordion('1');
    }, []);

    if (Role == 'Hr' || Role == 'Hr Manager') {
        role = 'Hr Manager';
    } else {
        role = Role;
    }

    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'How Do I ?', isActive: true, path: '' },
        { title: 'FAQs', isActive: false },
    ];

    /**
     * PC_FG_19 getCategory will get the value of category selected
     */
    const getCategory = (e) => {
        //
        setCategoryID(e.target.value);
        loadAccordion(e.target.value);
    };

    /**
     * PC_FG_04, 18, 25 loadAccordion makes api call to get faq with categoryID
     */
    const loadAccordion = async (category) => {
        //
        let faqDetails = {
            categoryID: category,
        };
        setIsLoading(false);
        faqBody = await getFAQ(faqDetails);

        /**
         * PC_FG_10 returned response is setstated in faqData
         */
        setfaqData(faqBody.data);
        setIsLoading(true);
    };

    /*
    PC_FG_12 deleteClicked will be invoked to pass the id to deleteFAQ
  */
    const deleteClicked = async (id) => {
        setIsLoading(false);
        await deleteFAQ({ faq_id: id });
        setIsLoading(true);
        /*
      PC_FG_18 invokes loadAccordion to render the faq list 
    */
        loadAccordion(categoryID);
    };

    /*
    PC_FG_26 redirects to FAQ Form on Add New FAQ button click
  */
    const redirect = () => {
        navigate(`/addfaq?pMode=Insert`);
    };

    /**
     * PC_FG_10, 25 bindAccordion maps the response data into respective fields
     */
    const bindAccordion = () => {
        if (faqData?.length === 0 || faqData?.length === undefined) {
            <div class="row justify-content-center">
                <img src="/Images/nodatafound.png" alt="no-records" style={{ width: '750px', height: '500px' }} />
                <span class="row justify-content-center margin-negative margin-negative">No FAQ found</span>
            </div>;
        } else {
            return faqData?.map((obj, index) => {
                return (
                    <div className="accordion-item my-2 border-0 px-0 accordian-table-sty mt-4">
                        <div className="accordion-header bg-white py-3 px-0 d-flex justify-content-between" id={`heading${obj.id}`}>
                            <button
                                className="accordion-button-custom collapsed text-truncate border-0 bg-white bold-text ps-3 font-15"
                                type="button"
                                data-bs-toggle={'collapse'}
                                data-bs-target={`#collapse${obj.id}`}
                                aria-expanded="false"
                                aria-controls={`collapse${obj.id}`}
                                title={obj.questions.length > 125 ? obj.questions : ''}
                            >
                                {obj.questions}
                            </button>
                            {/*Kebab Menu starts Here */}
                            {userRole === 'Hr Manager' ? (
                                <div className="me-4 align-self-center">
                                    <button
                                        type="button"
                                        className="btn p-0 align-self-center shadow-none"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <span>
                                            <img src="Images/kebab-icon.svg" alt="icon" />
                                        </span>
                                    </button>
                                    <ul className="dropdown-menu shadow-sm border-0">
                                        {/* PC_FG_27 redirects to faq form with faq_id to get the data prefilled for edit*/}
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12 faq-kebab-items mb-2"
                                                href={`/addfaq?FAQID=${obj.id}&pMode=Edit`}
                                            >
                                                <span>
                                                    <img className="pe-2" src="Images/hive-edit-icon.svg" alt="Edit" />
                                                </span>
                                                Edit
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12 faq-kebab-items"
                                                onClick={() => setDeleteID(obj.id)}
                                                data-bs-toggle="modal"
                                                data-bs-target="#logout"
                                            >
                                                <span>
                                                    <img className="pe-2" src="Images/hive-delete-icon.svg" alt="Delete" />
                                                </span>
                                                Delete
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        {/* Kebab Menu ends Here*/}
                        <div
                            id={`collapse${obj.id}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading${obj.id}`}
                            data-bs-parent={'#accordionExample'}
                        >
                            <div className="accordion-body bg-white pt-0">
                                <p className="font-13 medium-text text-break table-inlinetext-clr">{obj.answers}</p>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid mt-5">
                <div className="row justify-content-center mt-5">
                    <div className="col-md-11">
                        <BreadCrumbs data={breadCrumbsData} />
                        {/*FAQ'S starts here*/}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <h5 className="tt-bold font-15 faq-header">FAQ's</h5>
                            {userRole === 'Hr Manager' ? (
                                <button
                                    onClick={() => redirect()}
                                    className="btn hive-btn-primary"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img src="Images/hive-add-icon.svg" alt="add-arrow" className="me-2" />
                                    Add New FAQ'S
                                </button>
                            ) : (
                                ''
                            )}
                        </div>
                        {/*FAQ'S tab starts here*/}
                        <div className="tab-content px-0 mb-2" id="pills-tabContent">
                            <ul className="nav nav-pills ps-1" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        onClick={(e) => getCategory(e)}
                                        value="1"
                                        className={
                                            catId == 1
                                                ? 'nav-link px-0 active font-13 bold-text rounded-0 db-tab-style'
                                                : 'nav-link px-0 font-13 bold-text rounded-0 db-tab-style'
                                        }
                                        id="salary-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#salary"
                                        type="button"
                                        role="tab"
                                        aria-controls="salary"
                                        aria-selected="true"
                                    >
                                        Salary
                                    </button>
                                </li>
                                <li className="nav-item ms-5" role="presentation">
                                    <button
                                        onClick={(e) => getCategory(e)}
                                        value="2"
                                        className={
                                            catId == 2
                                                ? 'nav-link px-0 active font-13 bold-text rounded-0 db-tab-style'
                                                : 'nav-link px-0 font-13 bold-text rounded-0 db-tab-style'
                                        }
                                        id="tax-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#tax"
                                        type="button"
                                        role="tab"
                                        aria-controls="tax"
                                        aria-selected="false"
                                    >
                                        Tax
                                    </button>
                                </li>
                                <li className="nav-item ms-5" role="presentation">
                                    <button
                                        onClick={(e) => getCategory(e)}
                                        value="3"
                                        className={
                                            catId == 3
                                                ? 'nav-link px-0 active font-13 bold-text rounded-0 db-tab-style'
                                                : 'nav-link px-0 font-13 bold-text rounded-0 db-tab-style'
                                        }
                                        id="leaves-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#leaves"
                                        type="button"
                                        role="tab"
                                        aria-controls="leaves"
                                        aria-selected="false"
                                    >
                                        Leaves
                                    </button>
                                </li>
                                <li className="nav-item ms-5" role="presentation">
                                    <button
                                        onClick={(e) => getCategory(e)}
                                        value="4"
                                        className={
                                            catId == 4
                                                ? 'nav-link px-0 active font-13 bold-text rounded-0 db-tab-style'
                                                : 'nav-link px-0 font-13 bold-text rounded-0 db-tab-style'
                                        }
                                        id="recruitment-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#recruitment"
                                        type="button"
                                        role="tab"
                                        aria-controls="recruitment"
                                        aria-selected="false"
                                    >
                                        Recruitment
                                    </button>
                                </li>
                                <li className="nav-item ms-5" role="presentation">
                                    <button
                                        onClick={(e) => getCategory(e)}
                                        value="5"
                                        className={
                                            catId == 5
                                                ? 'nav-link px-0 active font-13 bold-text rounded-0 db-tab-style'
                                                : 'nav-link px-0 font-13 bold-text rounded-0 db-tab-style'
                                        }
                                        id="operations-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#operations"
                                        type="button"
                                        role="tab"
                                        aria-controls="operations"
                                        aria-selected="false"
                                    >
                                        Operations
                                    </button>
                                </li>
                            </ul>
                        </div>
                        {/*FAQ'S tab ends here*/}
                        {/*salary tab content starts here*/}
                        <div className="tab-pane fade show active" id="salary" role="tabpanel" aria-labelledby="salary-tab">
                            { }
                            { }
                            {categoryID == '1' ? (
                                <div className="row mb-4">
                                    <div className="accordion" id="accordionExample">
                                        {faqData?.length === 0 || faqData?.length === undefined ? (
                                            <div class="row justify-content-center">
                                                <img
                                                    src="/Images/nodatafound.png"
                                                    alt="no-records"
                                                    style={{ width: '750px', height: '500px' }}
                                                />
                                                <span class="row justify-content-center margin-negative">No FAQ found</span>
                                            </div>
                                        ) : (
                                            bindAccordion()
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/*salary tab content ends here*/}
                        {/*tax tab content starts here*/}
                        <div className={'tab-pane fade show'} id="tax" role="tabpanel" aria-labelledby="tax-tab">
                            {categoryID == '2' ? (
                                <div className="row mb-4">
                                    <div className="accordion" id="accordionExample">
                                        {faqData?.length === 0 || faqData?.length === undefined ? (
                                            <div class="row justify-content-center">
                                                <img
                                                    src="/Images/nodatafound.png"
                                                    alt="no-records"
                                                    style={{ width: '750px', height: '500px' }}
                                                />
                                                <span class="row justify-content-center margin-negative">No FAQ found</span>
                                            </div>
                                        ) : (
                                            bindAccordion()
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/*tax tab content ends here*/}
                        {/*leave tab content starts here*/}
                        <div className="tab-pane fade show" id="leaves" role="tabpanel" aria-labelledby="leaves-tab">
                            {categoryID == '3' ? (
                                <div className="row mb-4">
                                    <div className="accordion" id="accordionExample">
                                        {faqData?.length === 0 || faqData?.length === undefined ? (
                                            <div class="row justify-content-center">
                                                <img
                                                    src="/Images/nodatafound.png"
                                                    alt="no-records"
                                                    style={{ width: '750px', height: '500px' }}
                                                />
                                                <span class="row justify-content-center margin-negative">No FAQ found</span>
                                            </div>
                                        ) : (
                                            bindAccordion()
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/*leave tab content ends here*/}
                        {/*recruitment tab content starts here*/}
                        <div className={'tab-pane fade show '} id="recruitment" role="tabpanel" aria-labelledby="recruitment-tab">
                            {categoryID == '4' ? (
                                <div className="row mb-4">
                                    <div className="accordion" id="accordionExample">
                                        {faqData?.length === 0 || faqData?.length === undefined ? (
                                            <div class="row justify-content-center">
                                                <img
                                                    src="/Images/nodatafound.png"
                                                    alt="no-records"
                                                    style={{ width: '750px', height: '500px' }}
                                                />
                                                <span class="row justify-content-center margin-negative">No FAQ found</span>
                                            </div>
                                        ) : (
                                            bindAccordion()
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/*recruitment tab content ends here*/}
                        {/*operations tab content starts here*/}
                        <div className={'tab-pane fade show '} id="operations" role="tabpanel" aria-labelledby="operations-tab">
                            { }
                            {categoryID == '5' ? (
                                <div className="row mb-4">
                                    <div className="accordion" id="accordionExample">
                                        {faqData?.length === 0 || faqData?.length === undefined ? (
                                            <div class="row justify-content-center">
                                                <img
                                                    src="/Images/nodatafound.png"
                                                    alt="no-records"
                                                    style={{ width: '750px', height: '500px' }}
                                                />
                                                <span class="row justify-content-center margin-negative">No FAQ found</span>
                                            </div>
                                        ) : (
                                            bindAccordion()
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/*operations tab content ends here*/}
                    </div>
                </div>
                <div className="modal fade" id="logout" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-position">
                        <div className="modal-content border-none">
                            <div className="row">
                                <div className="col-md-12 float-start text-center p-5">
                                    <img className="mb-3 text-center align-items-center" src="Images/question-mark.svg" alt="alert" />
                                    <label className="w-100 bold-text font-14 text-center mb-3">Are you sure you want to Delete?</label>
                                    <div className="col-md-12 float-start text-center">
                                        <button type="button" className="btn hive-btn-error" data-bs-dismiss="modal">
                                            No
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                deleteClicked(deleteID);
                                            }}
                                            className="btn hive-btn-secondary"
                                            data-bs-dismiss="modal"
                                        >
                                            Yes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
